module.exports = __webpack_public_path__ + "img/logo-full-dark.5fbd086.svg";